class ResponsiveClass {
	MOBILE_MAX_WIDTH = 900
	SMALL_MAX_WIDTH = 1200
	SMALL_MIN_WIDTH = 900

	isSmaller = $state(false) // (max-width: 1200px) and (min-width: 900px)
	isMobile = $state(false)

	private mobileMediaQuery: MediaQueryList
	private smallMediaQuery: MediaQueryList

	constructor() {
		this.checkMobile()
		this.setupMediaQueryListener()
	}

	private checkMobile() {
		this.mobileMediaQuery = window.matchMedia(`(max-width: ${this.MOBILE_MAX_WIDTH}px)`)
		this.isMobile = this.mobileMediaQuery.matches

		this.smallMediaQuery = window.matchMedia(
			`(max-width: ${this.SMALL_MAX_WIDTH}px) and (min-width: ${this.SMALL_MIN_WIDTH}px)`
		)
		this.isSmaller = this.smallMediaQuery.matches
	}

	private setupMediaQueryListener() {
		const update = () => {
			this.isMobile = this.mobileMediaQuery.matches
			this.isSmaller = this.smallMediaQuery.matches
		}
		this.mobileMediaQuery.addEventListener("change", update)
		this.smallMediaQuery.addEventListener("change", update)
	}
}

export const Responsive = new ResponsiveClass()
